import { useRef, useState } from "react";
import { Upload, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";

export default function FileUpload({ fields = {}, onUploaded, label = "Upload file", accept = ".pdf,.doc,.docx,.xlsx,.pptx,.jpg,.jpeg,.png,.webp,.heic,.mp4,.mov", testid = "file-upload", small }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const onChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const fd = new FormData();
    fd.append("file", file);
    Object.entries(fields).forEach(([k, v]) => v !== undefined && v !== null && fd.append(k, String(v)));
    setBusy(true);
    try {
      const { data } = await api.post("/files/upload", fd);
      toast.success("File uploaded");
      onUploaded?.(data);
    } catch (err) {
      toast.error(errMsg(err, "Upload failed. Please try again."));
    } finally {
      setBusy(false);
      e.target.value = "";
    }
  };
  return (
    <>
      <input ref={ref} type="file" accept={accept} className="hidden" onChange={onChange} data-testid={`${testid}-input`} aria-label={label} />
      <button type="button" onClick={() => ref.current?.click()} disabled={busy} data-testid={testid}
        className={`inline-flex items-center gap-2 rounded-xl border-2 border-dashed border-slate-300 bg-white font-semibold text-slate-700 transition-colors hover:border-red-500 hover:text-red-600 disabled:opacity-60 ${small ? "px-3 py-1.5 text-xs" : "px-4 py-2.5 text-sm"}`}>
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Upload className="h-4 w-4" />}{busy ? "Uploading…" : label}
      </button>
    </>
  );
}
